module.exports = __webpack_public_path__ + "img/icon-edge.22e028c1.svg";